@if (!clp) {
  <div class="nav-container">
    <nav class="navbar navbar-light navbar-expand-md">
      <div class="navbar-items d-md-none">
        <div class="col">
          <a class="navbar-brand" href="#" [attr.aria-hidden]="!logoHref">
            @if (logoHref) {
              <a [href]="logoHref" target="_blank"><img class="logo" alt="Logo" [src]="logoUrl"></a>
            }
            @if (!logoHref && !!logoUrl) {
              <img class="logo" alt="Logo" [src]="logoUrl">
            }
          </a>
        </div>
        <div class="col get-help">
          <app-telephone [phoneNumber]="phoneNumber" class="" [displayText]="'Get Help'"></app-telephone>
        </div>
        <div class="col menu">
          <button (click)="toggleMenu()" class="navbar-toggler" type="button" aria-controls="navbarLinksJs"
            aria-label="Toggle navigation">
            @if (expanded === false) {
              <span class="fa fa-bars fa-lg"></span>
            }
            @if (expanded === true) {
              <span class="fa fa-times-circle-o fa-lg"></span>
            }
          </button>
        </div>
      </div>
      <div id="navbarLinksJs" class="collapse navbar-collapse justify-content-start" [style.background-color]="navbarBackgroundColor">
        <ul class="navbar-nav">
          @for (link of links; track link) {
            <li class="nav-item">
              @if (!link.isExternal && link.active) {
                <a class="nav-link d-none d-md-block" (mouseover)="link.hovering = true" (mouseout)="link.hovering = false"
                  [style.background-color]="(link.hovering || isActive([partnerName, link.route])) ? navbarHoverColor : navbarBackgroundColor"
                [routerLink]="[partnerName, link.route]" [class.is-active]="isActive([partnerName, link.route])" title="{{link.name}}">{{link.name}}</a>
              }
              @if (link.isExternal && link.active) {
                <a class="nav-link d-none d-md-block" (mouseover)="link.hovering = true" (mouseout)="link.hovering = false"
                  [style.background-color]="link.hovering ? navbarHoverColor : navbarBackgroundColor" href="{{link.route}}" target="_blank" rel="noopener" title="{{link.name}}">{{link.name}}&nbsp;&nbsp;
                  <span class="fa fa-external-link" aria-hidden="true"></span>
                </a>
              }
              @if (!link.isExternal && link.active) {
                <a (click)="navlinkClicked()" class="nav-link d-md-none" (mouseover)="link.hovering = true" (mouseout)="link.hovering = false"
                  [style.background-color]="(link.hovering || isActive([partnerName, link.route])) ? navbarHoverColor : navbarBackgroundColor"
                [routerLink]="[partnerName, link.route]" [class.is-active]="isActive([partnerName, link.route])" title="{{link.name}}">{{link.name}}</a>
              }
              @if (link.isExternal && link.active) {
                <a (click)="navlinkClicked()" class="nav-link d-md-none" (mouseover)="link.hovering = true" (mouseout)="link.hovering = false"
                  [style.background-color]="link.hovering ? navbarHoverColor : navbarBackgroundColor" href="{{link.route}}" target="_blank" title="{{link.name}}">{{link.name}}&nbsp;&nbsp;
                  <span class="fa fa-external-link" aria-hidden="true"></span>
                </a>
              }
            </li>
          }
        </ul>
      </div>
    </nav>
  </div>
}